<template>
  <div class="sp-template">
    <div class="h-title">供应商订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="订单号">
            <el-input type="textarea" v-model="conditions.orderIds" placeholder="多个订单号用回车分割"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search-form__buttons">
              <el-button  type="primary" size="small" @click="searchTask">搜 索</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane  label="待处理" name="2"></el-tab-pane>
          <el-tab-pane  label="完成" name="1"></el-tab-pane>
          <el-tab-pane  label="异常订单" name="0"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="!pendingShow">
        <el-table :data="tableData" stripe border @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="returnMsg" label="异常信息"></el-table-column>
          <el-table-column prop="supplierChannelCode" label="供应商渠道"></el-table-column>
          <el-table-column prop="supplierId" label="供应商"></el-table-column>
          <el-table-column prop="supplierOrderId" label="供应商ID"></el-table-column>
          <el-table-column prop="deleted" label="是否删除"></el-table-column>
          <el-table-column label="日期">
            <template slot-scope="scope">
              {{dateFormat(new Date(scope.row.createAt), 'yyyy-MM-dd HH:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="conditions.status == 0">
            <template slot-scope="scope">
              <el-button  type="text" size="mini" @click="processException(scope.row)">编辑订单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!--待处理-->
      <div v-show="pendingShow">
        <div style="text-align: right;">
          <el-button type="primary" size="small" @click="add">下单</el-button>
        </div>
        <el-table :data="tableDataPending" stripe border @selection-change="handleSelectionChangePending">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="productName" label="产品"></el-table-column>
          <el-table-column prop="totalCarton" label="总箱数"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination background @size-change="handleSizeChangePending" @current-change="handleCurrentChangePending" :current-page="currentPagePending" :page-sizes="[10, 50, 100, 200, 300, 400]" :page-size="pageSizePending" layout="total, sizes, prev, pager, next, jumper" :total="totalPending">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :visible.sync="dialogFormVisible" width="35%">
        <el-form :model="formData" size="small" label-position="left">
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商名称"  prop="supplierId" >
                <el-select @change="changeSupplier" v-model="formData.supplierId" filterable clearable placeholder="请选择供应商名称">
                  <el-option v-for="(c,i) in channelProvider" :key="i" :label="c.name" :value="c.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商产品名称"  prop="supplierChannelCode" >
                <el-select v-model="formData.supplierChannelCode" filterable clearable placeholder="请选择产品名称">
                  <el-option v-for="(c,i) in supplierChannelCodes" :value="c.code" :key="i" :label="c.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible=false">取 消</el-button>
          <el-button size="small" type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>

  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      dialogFormVisible:false,
      pendingShow: true,
      tableData: [],
      tableDataPending: [],
      multipleSelection: [],
      multipleSelectionPending: [],
      conditions: {
        batchIdTextArea: "",
        startDate: "",
        endDate: "",
        status: '2',
        orderIds:''
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizePending: 10,
      currentPagePending: 1,
      totalPending: 0,
      formData:{
        orderIds: [],
        supplierId: '',
        supplierChannelCode: ''
      },
      channelProvider: [],
      supplierChannelCodes: []
    }
  },
  components: {},
  created() {
    setTimeout(() => {
      // this.query()
      this.queryPending()
      this.querySupplierProduct()
    }, 1000);
  },
//     beforeRouteEnter(to, from, next) {
//     if (from.path === "/editorder") {
//       next(vm => {
//         vm.tableData = vm.orderListTable;
//         vm.conditions = vm.orderListConditions;
//         vm.isSearchMore = vm.orderListSearchMore;
//         vm.total = vm.orderListTable.length;
//         vm.needInitData = false;
//       });
//     } else {
//       next();
//     }
//   },
  methods: {
        ...mapMutations([
      "setManualTrackingNumbers",
      "setOrderListTable",
      "setOrderListConditions",
      "setOrderListSearchMore"
    ]),
    querySupplierProduct() {
      let _this = this;
      this.$request1({
        type: "get",
        url: '/channelsupplier/getSupplierChannel',
        xhrFields: {
          withCredentials: true
        }
      }).then(response => {
          _this.channelProvider = response.data.data;
          _this.supplierChannelCodes = [];
      })
    },
    changeSupplier () {
		  let sid = this.formData.supplierId;
      this.formData.supplierChannelCode = "";
      this.supplierChannelCodes = []
      this.channelProvider.forEach(a => {
        if (sid == a.id) {
          a.channel.forEach(b => {
            this.supplierChannelCodes.push(b);
          });
        }
      });
		},
    searchTask() {
      if(this.conditions.status === '2'){
        this.pendingShow = true
        this.currentPagePending = 1
        this.queryPending()
      }else{
        this.pendingShow = false
        this.currentPage = 1;
        this.query();
      }
    },
    query() {
      let orderIds = [];
      this.conditions.orderIds.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          orderIds.push(d);
        }
      });
      this.$request1({
        method: 'post',
        url: '/channelsupplier/supplierExceptionQuery',
        data: {
          orderIds: orderIds,
          succeed: this.conditions.status,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryPending(){
      this.$request1({
        method: 'post',
        // url: `${springHost}supplier/order/pending`,
        url: `supplier/order/pending`,
        data: {pageSize: this.pageSizePending, currentPage: this.currentPagePending}
      }).then(res => {
        if(res.data.success){
          this.tableDataPending = res.data.data.records
          this.totalPending = +res.data.data.total
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    submit(){
      if(!this.formData.supplierId){
        this.$message.error('请选择供应商')
        return
      }
      if(!this.formData.supplierChannelCode){
        this.$message.error('请选择供应商产品')
        return
      }

      let _this = this;
      this.$request1.post(
        '/channelsupplier/place-order',
        _this.formData,
        {
          withCredentials: true
        }
      ).then(res => {
        if(res.data.success){
          this.dialogFormVisible = false
          _this.queryPending()
          _this.formData.orderIds = []
          _this.formData.supplierId = ''
          _this.formData.supplierChannelCode = ''
        }
      })

    },
    add(){
      if(this.multipleSelectionPending.length == 0){
        this.$message.error('请选择订单')
        return
      }
      this.formData.orderIds = []
      this.multipleSelectionPending.forEach(e => {
        this.formData.orderIds.push(e.orderId)
      })
      this.dialogFormVisible = true
    },
    processException(rowOrder) {
      let orderId  = rowOrder.orderId;
      let rowOrderStatus = rowOrder.status;
      //console.log(orderId, rowOrderStatus);
      let editCarton = true;
      this.$router.push({
        path: "/editOrder",
        query: {
          orderId: orderId,
          editCarton: editCarton,
          issupp:true
        }
      });
      this.setOrderListTable(this.tableData);
      this.setOrderListConditions(this.conditions);
      this.setOrderListSearchMore(this.isSearchMore);
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChangePending(val) {
      this.multipleSelectionPending = val;
    },
    //分页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.query();
    },
    handleSizeChangePending(val) {
      this.currentPagePending = 1;
      this.pageSizePending = val;
      this.queryPending();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    handleCurrentChangePending(val) {
      this.currentPagePending = val;
      this.queryPending();
    },
    dateFormat(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style>
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
  white-space: pre-wrap !important;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/supplierorder.vue